import { faqItems } from '../content'
import { PageHero } from '../components/PageHero'
import { Link } from 'react-router-dom'

const related = [
  ['/disclaimer', 'Read our medical role and boundaries'],
  ['/how-we-help', 'Explore patient coordination support'],
  ['/enquiry', 'Start your free case review'],
  ['/pricing', 'Compare consultation fees and included services'],
  ['/pricing', 'Review payment arrangements'],
  ['/how-it-works#travel', 'See how a treatment journey is planned'],
  ['/privacy', 'Read how enquiry files and consent are handled'],
  ['/how-it-works#travel', 'Review the steps before travelling'],
  ['/how-it-works#travel', 'Explore treatment and travel planning'],
  ['/disclaimer', 'Read the emergency care boundary'],
  ['/terms', 'Read service terms and responsibilities'],
  ['/enquiry', 'Enquire for yourself or a family member'],
  ['/how-we-help', 'Explore medical language support'],
]

export function FAQ() {
  return <>
    <PageHero eyebrow="Frequently asked questions" title="Treatment in China: your questions answered." text="Understand the three stages, specialist matching, payment relationships, medical boundaries and what to share in the free case review." />
    <section className="faq-page section-pad">{faqItems.map(([question, answer], index) => <details id={`faq-question-${index + 1}`} key={question} open={index === 0}><summary><span>{String(index + 1).padStart(2, '0')}</span><h2>{question}</h2><i>+</i></summary><p>{answer} <Link to={related[index][0]}>{related[index][1]}</Link>.</p></details>)}</section>
  </>
}
